export const ADD_MENU_ITEM = '@Account/ADD_MENU_ITEM';
export const UPDATE_MENU_ITEM = '@Account/UPDATE_MENU_ITEM';
export const REMOVE_MENU_ITEM = '@Account/REMOVE_MENU_ITEM';
export const SET_NEED_REGISTRATION_FINISH =
  '@Account/SET_NEED_REGISTRATION_FINISH';
export const SET_USER = '@Account/SET_USER';
